package com.example.socialmediaapp.network

import com.example.socialmediaapp.data.models.Notification
import com.example.socialmediaapp.data.models.NotificationType
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ApiNotification(
    val id: String,
    @SerialName("user_id") val userId: String = "",
    val type: String,
    val title: String,
    val content: String,
    val timestamp: Long,
    @SerialName("is_read") val isRead: Int = 0,
    @SerialName("related_id") val relatedId: String? = null
) {
    fun toDomain() = Notification(
        id = id,
        type = when (type) {
            "message" -> NotificationType.MESSAGE
            "mention" -> NotificationType.MENTION
            "like" -> NotificationType.LIKE
            "follow" -> NotificationType.FOLLOW
            "subscription" -> NotificationType.SUBSCRIPTION
            else -> NotificationType.LIKE
        },
        title = title,
        content = content,
        timestamp = timestamp * 1000L,
        isRead = isRead != 0,
        relatedId = relatedId
    )
}

class NotificationsRepository(private val api: ApiClient) {

    suspend fun getNotifications(): Result<List<Notification>> = runCatching {
        api.get<List<ApiNotification>>("/api/notifications").map { it.toDomain() }
    }

    suspend fun markAllRead(): Result<Unit> = runCatching {
        api.post<MessageResponse>("/api/notifications/read-all")
    }
}
